import { useEffect, useState } from "react";

// Small matchMedia hook (mirrors the pattern in AppShell.tsx). SSR-safe default false.
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => (typeof window !== "undefined" ? window.matchMedia(query).matches : false));

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (event: MediaQueryListEvent) => setMatches(event.matches);
    setMatches(mql.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, [query]);

  return matches;
}

// Phone / small screen → capture-first. Desktop (>=1024px) → stats-first.
export function useIsCompact(): boolean {
  return useMediaQuery("(max-width: 1023px)");
}
